var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadExcelOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.21193 4.05664C0.827911 4.05664 0.516602 4.36795 0.516602 4.75197V11.7053C0.516602 12.0893 0.827912 12.4006 1.21193 12.4006H8.16522C8.54924 12.4006 8.86055 12.0893 8.86055 11.7053V4.75197C8.86055 4.36795 8.54924 4.05664 8.16522 4.05664H1.21193ZM2.78238 6.20703L4.18018 8.30373L2.62354 10.7054H3.58929L4.644 8.9391L5.74318 10.7054H6.75341L5.13958 8.3228L6.51197 6.20703H5.59069L4.67576 7.74461L3.74813 6.20703H2.78238Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.64247 1.34536L12.3791 1.34748C12.8677 1.34773 13.2638 1.74395 13.2638 2.23262V10.2193H12.1692V13.1866L10.6774 13.1866L12.3628 15.162L3.64246 15.162C3.15457 15.162 2.75906 14.7665 2.75906 14.2786V12.8866H1.90247V14.2786C1.90247 15.2395 2.68149 16.0186 3.64246 16.0186L13.0907 16.0186V16.0152L13.4905 16.4837L16.2381 13.1867L14.747 13.1867V10.2193H14.1203V2.23262C14.1203 1.27105 13.3411 0.491394 12.3795 0.490887L3.64247 0.48877C2.6815 0.488777 1.90248 1.2678 1.90248 2.22877V3.58559H2.75907V2.22877C2.75907 1.74088 3.15458 1.34536 3.64247 1.34536ZM13.997 13.9367L14.6368 13.9367L13.4837 15.3203L12.3032 13.9366L12.9192 13.9366V10.9693H13.997V13.9367Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2915 6.207L9.94478 6.20703",
    stroke: "currentColor",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2915 8.4913L9.94478 8.49133",
    stroke: "currentColor",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2915 10.7755L9.94478 10.7755",
    stroke: "currentColor",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadExcelOutline);
export default __webpack_public_path__ + "static/media/download-excel-outline.1aa9475a0dbfd51188454f940e755ad0.svg";
export { ForwardRef as ReactComponent };